// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","btnHolder":"Button_btnHolder__Jn5s1","btnContent":"Button_btnContent__aXZzT"};